import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { useEffect, useState } from 'react'

export function PHProvider({ children }: { children: React.ReactNode }) {
	const [hydrated, setHydrated] = useState(false)

	useEffect(() => {
		if (ENV.MODE === 'production' && ENV.POSTHOG_API_KEY) {
			posthog.init(ENV.POSTHOG_API_KEY, {
				api_host: ENV.POSTHOG_HOST,
				defaults: '2025-05-24',
				autocapture: false,
				loaded: (posthog) => {
					if (ENV.MODE === 'development') {
						posthog.debug()
					}
				},
			})
		}

		setHydrated(true)
	}, [])

	if (!hydrated) return <>{children}</>
	return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}
